/** Email types */
export const EMAIL_TYPES = {
    welcomeEmail: 'Welcome Email',
    coldEmail: 'Cold Email',
    followupEmail: 'Followup Email',
    rejectionEmail: 'Rejection Email',
    newsletterEmails: 'Newsletter emails',
    leadNurturingEmails: 'Lead nurturing emails',
    promotionalEmails: 'Promotional emails',
    milestoneEmails: 'Milestone emails',
    surveyEmails: 'Survey emails',
    generalEmail: 'General Email',
};
